"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _actions = require("../../../../../actions");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var buyerDefaultMessages = ['Se possível, marque encontros em locais públicos e movimentados.', 'Fique atento a preços abaixo do mercado e a excessos de facilidades.', 'Não faça pagamentos antes de verificar o que está sendo anunciado.', 'Havendo suspeitas, denuncie para a OLX.'];
var sellerDefaultMessages = ['Se possível, marque encontros em locais públicos e movimentados.', 'Desconfie de interessados que solicitam o envio do produto para fora do país.',
// eslint-disable-line max-len
'Atenção a comprovantes de transferências e depósitos falsos.', 'Havendo suspeitas, denuncie para a OLX.'];
function SecurityDetail(_ref) {
  var _ref$amISeller = _ref.amISeller,
    amISeller = _ref$amISeller === void 0 ? false : _ref$amISeller,
    _ref$buyerMessages = _ref.buyerMessages,
    buyerMessages = _ref$buyerMessages === void 0 ? buyerDefaultMessages : _ref$buyerMessages,
    _ref$sellerMessages = _ref.sellerMessages,
    sellerMessages = _ref$sellerMessages === void 0 ? sellerDefaultMessages : _ref$sellerMessages,
    closeModalAction = _ref.closeModalAction;
  var messages = amISeller ? sellerMessages : buyerMessages;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.TitleWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.TrustShield, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityTitle, {
        children: "Dicas de negocia\xE7\xE3o"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.AlertTriangle, {
          size: "18"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityText, {
          children: "A OLX nunca solicita c\xF3digos por liga\xE7\xE3o, chat ou WhatsApp"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.MapPin, {
          size: "18"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityText, {
          children: messages[0]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Info, {
          size: "18"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityText, {
          children: messages[1]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Eye, {
          size: "18"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityText, {
          children: messages[2]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ItemWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Flag, {
          size: "18"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecurityText, {
          children: messages[3]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ButtonWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: closeModalAction,
        children: "Ok, entendi"
      })
    })]
  });
}
SecurityDetail.propTypes = {
  closeModalAction: _propTypes.func.isRequired,
  amISeller: _propTypes.bool,
  buyerMessages: _propTypes.array,
  sellerMessages: _propTypes.array
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    closeModalAction: _actions.closeModal
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)(SecurityDetail);